{% block sw_cms_block_acris_blog_content %}
    <div class="sw-cms-block-acris-blog-content">
        <slot name="column"></slot>
    </div>
{% endblock %}
